import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const ModulationIndex = (props) => { 
    return (
        <div className="harmonicity fm-parameter">
          <div>
            Modulation
          </div>
          <div className="value">
            {props.modulation}
          </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      modulation: props.oscillator.modulationIndexParameter.get()
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModulationIndex);
